<template>
  <nav>
    <ul class="flex flex-col">
      <!-- content links -->
      <li class="px-10 pt-8 pb-4 border-b border-ricoma-gray-300">
        <span class="px-4 font-semibold uppercase text-xxs text-ricoma-gray-500">Content</span>
      </li>
      <VNavLink v-for="link in $options.contentLinks" :key="link.name" :linkProps="link" />

      <!-- manage links -->
      <li class="px-10 pt-8 pb-4 border-b border-ricoma-gray-300">
        <span class="px-4 font-semibold uppercase text-xxs text-ricoma-gray-500">Manage</span>
      </li>
      <VNavLink v-for="link in $options.manageLinks" :key="link.name" :linkProps="link" />

      <!-- training links -->
      <li class="px-10 pt-8 pb-4 border-b border-ricoma-gray-300">
        <span class="px-4 font-semibold uppercase text-xxs text-ricoma-gray-500">Training</span>
      </li>
      <VNavLink v-for="link in $options.trainingLinks" :key="link.name" :linkProps="link" />
    </ul>
  </nav>
</template>

<script>
import VNavLink from '@/components/base/VNavLink';

const CONTENT_LINKS = [
  { to: '/admin/pre-training', name: 'Pre-training', allowAccess: ['admin'] },
  { to: '/admin/training-videos', name: 'Training Videos', allowAccess: ['admin'] },
  { to: '/admin/post-training-videos', name: 'Post Training Videos', allowAccess: ['admin'] },
  { to: '/admin/products', name: 'Products', allowAccess: ['admin'] },
  { to: '/admin/accessories', name: 'Accessories', allowAccess: ['admin'] },
  { to: '/admin/notifications', name: 'Notifications', allowAccess: ['admin', 'service', 'tech'] },
];

const MANAGE_LINKS = [
  {
    to: '/admin',
    exact: true,
    name: 'Contacts',
    allowAccess: ['admin', 'service', 'tech', 'europe'],
  },
  {
    to: '/admin/customers',
    name: 'Customers',
    allowAccess: ['admin', 'service', 'tech', 'europe'],
  },
  { to: '/admin/payout-tags', name: 'Payout Tags', allowAccess: ['admin'] },
  { to: '/admin/sales-reps', name: 'Sales Reps', allowAccess: ['admin'] },
  {
    to: '/admin/referrals-history',
    name: 'Referral History',
    allowAccess: ['admin', 'accounting'],
  },
  {
    to: '/admin/referrals-pending-payouts',
    name: 'Influencer Pending Payouts',
    allowAccess: ['admin', 'accounting'],
  },
  {
    to: '/admin/referrals-general-pending-payouts',
    name: 'General Pending Payouts',
    allowAccess: ['admin', 'accounting'],
  },
];

const TRAINING_LINK = [
  {
    to: '/admin/training-schedule-us/US',
    name: 'Training Schedule US',
    allowAccess: ['admin', 'service', 'tech'],
  },
  {
    to: '/admin/training-schedule-eu/EU',
    name: 'Training Schedule EU',
    allowAccess: ['admin', 'europe'],
  },
];

const hasAccess = (route, user) => {
  return route.allowAccess.includes(user.role);
};

export default {
  name: 'NavLinks',
  components: { VNavLink },
  contentLinks: [],
  manageLinks: [],
  traningLinks: [],
  created() {
    this.$options.contentLinks = CONTENT_LINKS.filter(link => hasAccess(link, this.$user));
    this.$options.manageLinks = MANAGE_LINKS.filter(link => hasAccess(link, this.$user));
    this.$options.trainingLinks = TRAINING_LINK.filter(link => hasAccess(link, this.$user));
  },
};
</script>
